export const VIDEO_STATUSES = [
  'uploading',
  'processing',
  'ready',
  'failed',
] as const;

export type VideoStatus = (typeof VIDEO_STATUSES)[number];

export const SOURCE_CONTENT_TYPES = ['video/mp4', 'video/quicktime'] as const;

export type SourceContentType = (typeof SOURCE_CONTENT_TYPES)[number];

export const POSTER_CONTENT_TYPES = [
  'image/jpeg',
  'image/png',
  'image/webp',
] as const;

export type PosterContentType = (typeof POSTER_CONTENT_TYPES)[number];

export const MAX_SOURCE_BYTES = 2 * 1024 ** 3;
export const MAX_POSTER_BYTES = 5 * 1024 ** 2;
export const MAX_BULK_VIDEOS = 20;

export const VIDEO_ORDER_BY = [
  'created_at',
  'updated_at',
  'title',
  'position',
] as const;

export type VideoOrderBy = (typeof VIDEO_ORDER_BY)[number];

export const NO_PLACEMENT = 'none';
export const PLACEMENT_KEY_PATTERN = /^[a-z0-9_]+(\.[a-z0-9_]+)*$/;
export const PLACEMENT_KEY_MAX_LENGTH = 100;
export const PLACEMENT_DESCRIPTION_MAX_LENGTH = 200;
export const PLACEMENT_KEY_EXAMPLE = 'onboarding.welcome_week.day_1';
